var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ebooks",staticStyle:{"padding-bottom":"0"}},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12",staticStyle:{"height":"100vh"}},[_c('iframe',{attrs:{"id":"iframe-ebook","src":_vm.ebook_link,"frameborder":"0","allowfullscreen":"","width":"100%","height":"100%"}})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }